import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#EC068D',
        },
    },
    typography: {
        fontFamily: 'LINESeedSansTH_Rg'
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontFamily: 'LINESeedSansTH_Bd',
                    textTransform: 'none',
                    boxShadow: 'none',
                    borderRadius: '8px',
                    variants: [
                        {
                            props: { variant: 'contained', color: 'primary' },
                            style: {
                                height: '40px',
                                backgroundImage: `linear-gradient(90deg,${theme.palette.primary.main},#F2758E)`,
                                backgroundColor: theme.palette.primary.main,
                                '&:hover': {
                                    boxShadow: 'none',
                                },
                                '&:active': {
                                    boxShadow: 'none',
                                },
                                '&.Mui-disabled': {
                                    background: '#c4c8cf',
                                    color: 'white'
                                },
                            }
                        },
                        {
                            props: { variant: 'outlined', color: 'primary' },
                            style: {
                                height: '40px',
                            }
                        }
                    ],
                })
            }
        }
    }
});

export default function AppTheme({ children }: React.PropsWithChildren) {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}